import * as tslib_1 from "tslib";
import * as React from 'react';
import styled from 'styled-components';
import validProp from '@emotion/is-prop-valid';
var StyledIcon = React.forwardRef(function (props, ref) {
    var title = props.title, size = props.size, otherProps = tslib_1.__rest(props, ["title", "size"]);
    var iconProps = {
        viewBox: '0 0 24 24',
        height: props.height !== undefined ? props.height : size,
        width: props.width !== undefined ? props.width : size,
        // @ts-ignore - aria is not always defined on SVG in React TypeScript types
        'aria-hidden': title == null ? 'true' : undefined,
        focusable: 'false',
        role: title != null ? 'img' : undefined,
        "fill": "currentColor",
    };
    var svgProps = Object.keys(otherProps).reduce(function (p, k) {
        if (validProp(k)) {
            p[k] = otherProps[k];
        }
        return p;
    }, {});
    return (React.createElement("svg", tslib_1.__assign({}, iconProps, svgProps, { ref: ref }),
        title && React.createElement("title", { key: "SocialLinkedinCircular-title" }, title),
        React.createElement("path", { d: "M10.033 15.3h-1.6v-5.199h1.6V15.3zm-.8-5.866c-.577 0-.866-.267-.866-.8a.74.74 0 0 1 .25-.567.868.868 0 0 1 .616-.233c.577 0 .866.268.866.801s-.288.799-.866.799zm6.734 5.866h-1.633v-2.9c0-.755-.268-1.133-.801-1.133-.422 0-.699.211-.834.633-.043.067-.066.201-.066.4v3H11v-3.533c0-.8-.012-1.355-.033-1.666h1.4l.1.699c.367-.556.9-.833 1.633-.833.557 0 1.006.194 1.35.583.346.389.518.95.518 1.684V15.3zM12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7z", key: "k0" })));
});
export var SocialLinkedinCircular = styled(StyledIcon).withConfig({ displayName: "SocialLinkedinCircular", componentId: "sc-185vbdo" })(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n"])));
SocialLinkedinCircular.displayName = 'SocialLinkedinCircular';
export var SocialLinkedinCircularDimensions = { height: 24, width: 24 };
var templateObject_1;
